const websiteHeader = document.querySelector("header");
const desktopUtilityBar = document.querySelector(".adm-utilitybar");
const desktopMegaHeader = document.querySelector(".adm-navbar");

if (websiteHeader) {

  // Functions
  const accExpandElement = (elem, focus, delay) => {
    elem?.setAttribute("aria-hidden", "false");
    elem?.setAttribute("aria-expanded", "true");

    if (delay) {
      setTimeout(() => {focus?.focus()}, delay);
    } else {
      focus?.focus();
    }
  }

  const accHideElement = (elem, focus, delay) => {
    elem?.setAttribute("aria-hidden", "true");
    elem?.setAttribute("aria-expanded", "false");

    if (delay) {
      setTimeout(() => {focus?.focus()}, delay);
    } else {
      focus?.focus();
    }
  }

  const closeUtilDropdowns = (dropdownMenu, expandableLink, pressedKeyCode) => {
    switch (true) {
      // Utility Bar - Left side
      case dropdownMenu?.classList.contains("adm-dropdown-content"):
        dropdownMenu?.classList.remove("adm-dropdown-content-expanded");
        expandableLink?.children?.[0].classList.remove("adm-utilitybar-arrow-expanded-js")
        expandableLink?.children?.[1].classList.remove("adm-utilitybar-arrow-hidden-js")
        if (pressedKeyCode) accHideElement(dropdownMenu, expandableLink)
        else accHideElement(dropdownMenu)
        break;

      // Utility Bar - Language
      case dropdownMenu?.classList.contains("adm-dropdown-content-util-right"):
        dropdownMenu?.classList.remove("adm-dropdown-content-util-right-expanded");
        if (pressedKeyCode) accHideElement(dropdownMenu, expandableLink)
        else accHideElement(dropdownMenu)
        break;

      // Utility Bar - Search Box
      case dropdownMenu?.classList.contains("adm-div-searchbox-dropdown"):
        dropdownMenu.style.visibility = "hidden";
        dropdownMenu.style.opacity = "0";
        dropdownMenu?.nextElementSibling?.classList.remove('adm-div-dark-background-util-active', 'adm-div-dark-background-util-mini');
        dropdownMenu?.nextElementSibling?.nextElementSibling?.classList.remove("adm-div-search-util-typeahead-container-active");
        expandableLink?.classList.remove("adm-utilitybar-icon-link-selected");
        websiteHeader?.classList.remove("scroll-listener");
        if (pressedKeyCode) accHideElement(dropdownMenu, expandableLink)
        else accHideElement(dropdownMenu)
        break;
    }
  }

  const doubleCtaTabKeypress = (index, array, event, link, dropdownNextLink) => {
    if (index === 0) {
      if (event.shiftKey) {
        link?.focus();
      } else {
        array?.[1].focus();
      }
    } else {
      if (event.shiftKey) {
        array?.[0].focus()
      } else {
        dropdownNextLink?.focus();
      }
    }
  }

  const ctaTabKeypress = (index, array, event, link, dropdownNextLink) => {
    switch (array?.length) {
      // Two articles
      case 2:
        doubleCtaTabKeypress(index, array, event, link, dropdownNextLink);
        break;
      
      // One Image / No Image
      case 1:
        if (event.shiftKey) link.focus();
        else dropdownNextLink?.focus();
        break;
    }
  }

  const addCtaEvents = (l1CTAs, link, submenuLinkIndex, dropdownNextLink) => {
    if (submenuLinkIndex === 0) {
      l1CTAs.forEach((cta, index, array) => {
        cta?.setAttribute("tabindex", "-1");
        cta?.addEventListener("keydown", (event) => {
          const pressedKeyCode = event.which || event.keyCode;
          if (pressedKeyCode === 9) {
            event.preventDefault();
            ctaTabKeypress(index, array, event, link, dropdownNextLink);            
          } else if (pressedKeyCode === 27) {
            link.focus();
          }
        })
      })
    }
  }

  const l2LinkSpaceKeypress = (index, l1CTAs, dropdownMenu, link, dropdownLinks, firstdropdownLink) => {
    if (index === 0 && l1CTAs?.length) {
      accExpandElement(dropdownMenu, l1CTAs?.[0]);
    }
    else if (link?.hasAttribute("aria-haspopup")) {
      if (!dropdownLinks?.[0]) accExpandElement(dropdownMenu, firstdropdownLink)
      else if (dropdownLinks?.[0]) accExpandElement(dropdownMenu, dropdownLinks?.[0])
    }
  }

  const AddL2LinkEvents = (link, dropdownMenu, dropdownNextLink, expandableLink, {index, l1CTAs, dropdownLinks, firstdropdownLink}) => {
    link?.addEventListener("keydown", (event) => {
      const pressedKeyCode = event.which || event.keyCode;

      switch (pressedKeyCode) {
        // SPACE key pressed
        case 32:
          event.preventDefault();
          l2LinkSpaceKeypress(index, l1CTAs, dropdownMenu, link, dropdownLinks, firstdropdownLink);
          break;

        // TAB key pressed
        case 9:
          if (!event.shiftKey && dropdownNextLink) {
            event.preventDefault();
            dropdownNextLink?.focus();
          } else if (!event.shiftKey && !dropdownNextLink) {
            event.preventDefault();
            accHideElement(dropdownMenu, expandableLink)
          }
          break;

        // ESCAPE key pressed
        case 27:
            event.preventDefault();
            accHideElement(dropdownMenu, expandableLink)
          break;
      }
    })
  }

  const closeDropdownFocusout = (dropdownMenu) => {
    dropdownMenu?.addEventListener("focusout", () => {
      setTimeout(() => {    
        if (!dropdownMenu?.contains(document.activeElement)) {
          accHideElement(dropdownMenu);
        }
      }, 0);
    })
  }

  const closeL2DropdownMenuAcc = (dropdownMenu, link) => {
    dropdownMenu?.addEventListener("keydown", (event) => {
      const pressedKeyCode = event.which || event.keyCode;
       
      if (pressedKeyCode === 27) {
        event.preventDefault();
        accHideElement(dropdownMenu, link);
      }
    })
  }

    // Open megamenu
    let tempMegamenuReference;
    const openMegamenu = (megamenu) => {
        megamenu?.classList.add("adm-meganav-expanded");
        accExpandElement(megamenu, megamenu.querySelector("a"), 100);
        tempMegamenuReference = megamenu;
        window.addEventListener("mousedown", megamenuOutsideClickListener)
    }

    const megamenuOutsideClickListener = (event) => {
        if (!tempMegamenuReference?.parentElement?.contains(event.target)) {
            closeMegamenu(tempMegamenuReference);
            window.removeEventListener("mousedown", megamenuOutsideClickListener);
        }
        else if (!tempMegamenuReference?.contains(event.target)) {
            window.removeEventListener("mousedown", megamenuOutsideClickListener);
        }
    }

    // Close megamenu
    const closeMegamenu = (megamenu) => {
        megamenu?.classList.remove("adm-meganav-expanded");
        accHideElement(megamenu);
    }

  if (desktopUtilityBar) {
    const utilityBarExpandableLinks = desktopUtilityBar?.querySelectorAll("[aria-haspopup]");
    const searchBoxInput = document.querySelector('#search-box-input');

    utilityBarExpandableLinks?.forEach((expandableLink) => {
      const dropdownMenu = expandableLink?.nextElementSibling;
      const dropdownLinks = dropdownMenu?.querySelectorAll("a");
      const typeAheadContainer = expandableLink?.parentElement?.querySelector(".adm-div-search-util-typeahead-container");

      // Open dropdown
      expandableLink?.addEventListener("keydown", (event) => {
        const pressedKeyCode = event.which || event.keyCode;

        // SPACE key pressed
        if (pressedKeyCode === 32) {
          event.preventDefault();
          switch (true) {
            // Utility Bar - Left side
            case dropdownMenu?.classList.contains("adm-dropdown-content"):
              dropdownMenu?.classList.add("adm-dropdown-content-expanded");
              expandableLink?.children?.[0].classList.add("adm-utilitybar-arrow-expanded-js")
              expandableLink?.children?.[1].classList.add("adm-utilitybar-arrow-hidden-js")
              accExpandElement(dropdownMenu, dropdownLinks?.[0])
              break;

            // Utility Bar - Language
            case dropdownMenu?.classList.contains("adm-dropdown-content-util-right"):
              dropdownMenu?.classList.add("adm-dropdown-content-util-right-expanded");
              accExpandElement(dropdownMenu, dropdownLinks?.[0])
              break;

            // Utility Bar - Search Box
            case dropdownMenu?.classList.contains("adm-div-searchbox-dropdown"):
              dropdownMenu.style.visibility = "visible";
              dropdownMenu.style.opacity = "1";
              dropdownMenu?.nextElementSibling.classList.add('adm-div-dark-background-util-active');
              websiteHeader?.classList.add("scroll-listener");
              accExpandElement(dropdownMenu, searchBoxInput, 100)
              break;
          }
        } else if (pressedKeyCode === 13 && dropdownMenu?.classList.contains("adm-dropdown-content-util-right")) {
          event.preventDefault();
          dropdownMenu?.classList.add("adm-dropdown-content-util-right-expanded");
          accExpandElement(dropdownMenu, dropdownLinks?.[0])
        }
      })

      // Close dropdown - Focus out
      dropdownMenu?.addEventListener("focusout", () => {
        setTimeout(() => {
          if (!dropdownMenu?.contains(document.activeElement) && !typeAheadContainer?.contains(document.activeElement)) {
            closeUtilDropdowns(dropdownMenu, expandableLink);
          }
        }, 0);
      })
      typeAheadContainer?.addEventListener("focusout", () => {
        setTimeout(() => {    
          if (!dropdownMenu?.contains(document.activeElement) && !typeAheadContainer?.contains(document.activeElement)) {
            closeUtilDropdowns(dropdownMenu, expandableLink);
          }
        }, 0);
      })

      // Close dropdown - Escape key
      dropdownLinks?.forEach(link => {
        link.addEventListener("keydown", (event) => {
          const pressedKeyCode = event.which || event.keyCode;
  
          // ESCAPE key pressed
          if (pressedKeyCode === 27) {
            event.preventDefault();
            closeUtilDropdowns(dropdownMenu, expandableLink, pressedKeyCode);
          }
        })
      })
    })
  }

  if (desktopMegaHeader) {
    const allMegamenus = desktopMegaHeader.querySelectorAll(".adm-meganav");
    const l1ExpandableLinks = desktopMegaHeader.querySelectorAll(".adm-li-navigation-menu > [aria-haspopup]");
    
    // Add tabindex -1 to every megamenu CTA
    allMegamenus?.forEach(megamenu => {
      megamenu?.querySelectorAll("div.adm-btn.adm-bg-navy > a")?.forEach(cta => cta?.setAttribute("tabindex", "-1"))
      megamenu?.querySelectorAll("div.adm-btn.adm-bg-white > a")?.forEach(cta => cta?.setAttribute("tabindex", "-1"))
    })

    l1ExpandableLinks?.forEach(expandableLink => {
      const dropdownMenu = expandableLink?.nextElementSibling;
      const dropdownLinks = dropdownMenu?.querySelectorAll(".adm-li-navigation-lvl1 > a");
      
      // Get L1 CTAs
      const l1CTAsTemp = [
        dropdownMenu?.firstElementChild?.children?.[1]?.querySelector("div.adm-btn.adm-bg-navy > a"),
        dropdownMenu?.firstElementChild?.children?.[1]?.querySelector("div.adm-btn.adm-bg-white > a"),
        dropdownMenu?.firstElementChild?.children?.[2]?.querySelector("div.adm-btn.adm-bg-navy > a"),
      ];
      const l1CTAs = l1CTAsTemp?.filter(function(item) {
        return item !== null && item !== undefined
      })
      
      // Open megamenu
      expandableLink?.addEventListener("keydown", (event) => {
        const pressedKeyCode = event.which || event.keyCode;

        // SPACE key pressed
        if (pressedKeyCode === 32) {
          event.preventDefault();
          openMegamenu(dropdownMenu);
        }
      })

        // Open/close megamenu on click ("click" event runs after "focus")
        expandableLink.addEventListener("click", () => {
            allMegamenus?.forEach(megamenu => {
                // Close all megamenus other than the one related to L1 item (if it's closed)
                if (megamenu === dropdownMenu && dropdownMenu.getAttribute("aria-hidden") === "true") {
                    openMegamenu(dropdownMenu);
                } else {
                    closeMegamenu(megamenu);
                }
            })
        })

        // Prevent focus effect on click
        expandableLink.addEventListener("mousedown", (e) => e.preventDefault())

        // Close megamenu on L1 item focus ("focus" event runs after "mousedown")
        expandableLink?.addEventListener("focus", () => {
            allMegamenus?.forEach(megamenu => {
                closeMegamenu(megamenu);
            })
        })

      dropdownLinks?.forEach((link, index, array) => {
        const l2DropdownMenu = link?.nextElementSibling;
        const l2DropdownLinks = l2DropdownMenu?.querySelectorAll("a");
        const firstdropdownLink = l2DropdownMenu?.querySelector("a");
        const dropdownNextLink = array?.[index + 1];
        const l2Link = link;

        // On CTA key press events
        addCtaEvents(l1CTAs, link, index, dropdownNextLink);

        // Enter submenu, skip it or close current one
        const enterRelevantVars = {index, l1CTAs, l2DropdownLinks, firstdropdownLink};
        AddL2LinkEvents(link, l2DropdownMenu, dropdownNextLink, expandableLink, enterRelevantVars);

        // Close submenu (acc)
        closeDropdownFocusout(l2DropdownMenu);
        closeL2DropdownMenuAcc(l2DropdownMenu, link);

        // Close submenu on last item tab keypress
        l2DropdownLinks?.[l2DropdownLinks.length - 1]?.addEventListener("keydown", (event) => {
            const pressedKeyCode = event.which || event.keyCode;
            if (!event.shiftKey && pressedKeyCode === 9) {
                event.preventDefault();
                accHideElement(l2DropdownMenu, l2Link);
            }
        })
      })
    })
      
    // Add smooth transition to megamenu
    setTimeout(() => {
      allMegamenus?.forEach(megamenu => {
        const parentElement = megamenu.parentElement;
        const previousElement = megamenu.previousElementSibling;
        const renderMegamenu = () => {
          parentElement.appendChild(megamenu);
          parentElement.removeEventListener("mouseenter", renderMegamenu);
          previousElement.removeEventListener("focus", renderMegamenu);
          setTimeout(() => {
            megamenu.style.transition = "opacity 0.3s, visibility 0.3s";
          }, 10);
        }

        megamenu.remove();
        parentElement.addEventListener("mouseenter", renderMegamenu);
        previousElement.addEventListener("focus", renderMegamenu);
      })
    }, 500);
  }
}